import { WriteBackFieldKey } from 'src/services/candidates/candidates.types';

// JT1-1534: i18n key for each write-back field's display label (shown in the confirm dialog).
export const WRITE_BACK_FIELD_LABEL_KEY: Record<WriteBackFieldKey, string> = {
  salary_expectations: 'profile.write_back.fields.salary_expectations',
  notice_period: 'profile.write_back.fields.notice_period',
  job_types: 'profile.write_back.fields.job_types',
  work_styles: 'profile.write_back.fields.work_styles',
  work_rights: 'profile.write_back.fields.work_rights',
  education_level: 'profile.write_back.fields.education_level',
};

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

type SalaryTuple = { min_amount: number; max_amount: number; period: string };

/**
 * Render a raw write-back conflict value (enum string, enum array, or salary tuples — as sent by the
 * API) into a human string, reusing the existing enum i18n namespaces. Notice period uses the
 * relabelled `notice_period_type` keys (JT1-1528), consistent with the list column + record panel.
 */
export function formatWriteBackValue(field: WriteBackFieldKey, value: unknown, t: TranslateFn): string {
  if (value == null || (Array.isArray(value) && value.length === 0)) return t('common.none');

  switch (field) {
    case 'notice_period':
      return t(`enums.notice_period_type.${value}`);
    case 'education_level':
      return t(`enums.education_level.${value}`);
    case 'job_types':
      return (value as string[]).map((v) => t(`enums.job_type.${v}`)).join(', ');
    case 'work_styles':
      return (value as string[]).map((v) => t(`enums.work_style.${v}`)).join(', ');
    case 'work_rights':
      return (value as string[]).map((v) => t(`enums.work_rights.${v}`)).join(', ');
    case 'salary_expectations':
      return (value as SalaryTuple[])
        .map((s) => `${s.min_amount.toLocaleString()}–${s.max_amount.toLocaleString()} / ${s.period}`)
        .join(', ');
    default:
      return String(value);
  }
}
